(function () {
  function pendingSlots() {
    return Array.prototype.filter.call(document.querySelectorAll('[data-mcm-look-handle]'), function (el) {
      if (el.getAttribute('data-mcm-look-upgraded') === '1') return false;
      // Similar Products already renders full Liquid cards. Replacing them via Algolia
      // can wipe the first slide when enrich/cardHtml misses — leave Liquid as-is.
      if (el.closest('[id*="similar_products"], [id*="__similar_products"]')) return false;
      return true;
    });
  }

  function fillSiblingSwatches(root) {
    var nodes = (root || document).querySelectorAll('[data-mcm-look-sibling]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.getAttribute('data-mcm-look-sibling-loaded') === '1') return;
      el.setAttribute('data-mcm-look-sibling-loaded', '1');
      var handle = el.getAttribute('data-mcm-look-sibling');
      if (!handle) return;
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          var src = product && (product.featured_image || (product.images && product.images[0]));
          if (src && String(src).indexOf('//') === 0) src = 'https:' + src;
          if (!src) {
            el.remove();
            return;
          }
          if (String(src).indexOf('?') === -1) src += '?width=80';
          el.innerHTML = '<img src="' + String(src).replace(/"/g, '&quot;') + '" alt="" width="16" height="16" loading="lazy">';
          el.classList.remove('is-pending');
        })
        .catch(function () {
          el.remove();
        });
    });
  }

  function upgrade() {
    var nodes = pendingSlots();
    var A = window.McmAlgolia;
    if (!nodes.length || !A || !A.cardHtml || !A.enrich) return false;
    nodes.forEach(function (el) {
      el.setAttribute('data-mcm-look-upgraded', '1');
    });
    var hits = nodes.map(function (el) {
      var handle = el.getAttribute('data-mcm-look-handle');
      return {
        handle: handle,
        title: el.getAttribute('data-mcm-look-title') || '',
        url: '/products/' + handle,
        id: el.getAttribute('data-mcm-look-id') || ''
      };
    });
    A.enrich(hits, '', 4).then(function () {
      hits.forEach(function (hit, index) {
        var el = nodes[index];
        if (!el || !el.isConnected) return;
        // Keep the Liquid card when Algolia has nothing useful — never leave an empty slide.
        if (!hit._shopify) return;
        var html = A.cardHtml(hit, { imageWidth: 800 });
        if (!html) {
          var cartItem = el.closest('.mcm-cart-upsell__item');
          if (cartItem) {
            var list = cartItem.parentNode;
            cartItem.remove();
            if (list && list.classList && list.classList.contains('mcm-cart-upsell__list') && !list.querySelector('.mcm-cart-upsell__item')) {
              var block = list.closest('.mcm-cart-upsell');
              if (block) block.remove();
            }
          }
          return;
        }
        el.innerHTML = html;
        if (A.hydrateSwatches) A.hydrateSwatches(el);
      });
    });
    return true;
  }

  function start() {
    fillSiblingSwatches(document);
    if (upgrade()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      fillSiblingSwatches(document);
      if (upgrade() || tries > 80) clearInterval(timer);
    }, 100);
  }

  // One-shot refresh when recommendation AJAX injects new look slots.
  document.addEventListener('mcm:look-slots-added', function () {
    fillSiblingSwatches(document);
    upgrade();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
